import { render, staticRenderFns } from "./Sinal.vue?vue&type=template&id=66fd392c&"
import script from "./Sinal.vue?vue&type=script&lang=js&"
export * from "./Sinal.vue?vue&type=script&lang=js&"
import style0 from "./Sinal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports